export const isPlayerNextPolicy = (player, policyId) => {
  return player?.nextPolicy?.id === policyId;
}